module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alert":{"alreadyLoggedIn":"A user is already logged in. Please refresh the page to continue."},"problem":{"401_2":"Incorrect email address and/or password."}}}')
  delete Component.options._Ctor
}
